import type { JSX } from 'react';
import { Controller, FieldValues, Path, PathValue } from 'react-hook-form';

import { FormFieldWrapperProps } from '@/widgets/ServiceFormTemplate';

import { SelectProps, Select } from './Select';

type Props<T extends FieldValues, OptionValue extends string = string> = Omit<
  SelectProps<OptionValue>,
  'defaultValue'
> &
  FormFieldWrapperProps<T> & {
    defaultValue?: PathValue<T, Path<T>>;
    useValueForOnChange?: boolean;
  };

export function FormSelect<T extends FieldValues = FieldValues, OptionValue extends string = string>({
  name,
  control,
  errorMessage,
  onChange,
  allowClear = false,
  defaultValue,
  useValueForOnChange,
  ...restProps
}: Props<T, OptionValue>): JSX.Element {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { ref: _ref, ...field }, fieldState: { error: fieldError } }): JSX.Element => (
        // TODO: deal with ts Error #MVSUSLUH-3655
        // @ts-ignore
        <Select
          {...restProps}
          {...field}
          pinnedOptionLabel={restProps.pinnedOptionLabel}
          errorMessage={fieldError?.message || errorMessage}
          allowClear={allowClear}
          // @ts-ignore
          onChange={(value, option): void => {
            field.onChange(useValueForOnChange ? value : option);
            onChange?.(value, option);
          }}
        />
      )}
    />
  );
}
